/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */
import React, { lazy, useEffect, useState, Suspense } from 'react';
import { hot } from 'react-hot-loader/root';
import { Provider, useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import mixpanel from 'mixpanel-browser';
import store from './redux/store';
import DashboardRoutes from './routes/admin/dashboard';
import Auth from './routes/auth';
import Admin from './routes/admin';
import UserflowRoute from './routes/admin/userflow';
import './static/css/style.css';
import config from './config/config';
import ProtectedRoute from './components/utilities/protectedRoute';
import UserAuthenticationProvider from './config/auth/token_provider';
import { changeRtlMode, changeLayoutMode, changeMenuMode } from './redux/themeLayout/actionCreator';
import GQLProvider from './config/auth/graphql-provider';

const { theme } = config;
const ProcessingPayment = lazy(() => import('./container/pages/Processing-Payment'));

const ProviderConfig = () => {
  const { rtl, isLoggedIn, topMenu, darkMode, auth } = useSelector(state => {
    return {
      darkMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      isLoggedIn: state.auth.login,
      auth: state.fb.auth,
    };
  });

  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    return () => (unmounted = true);
  }, [setPath]);

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <Router basename={process.env.PUBLIC_URL}>
          <Route path="/" component={Admin} />
        </Router>
      </ThemeProvider>
    </ConfigProvider>
  );
};

const App = () => {
  mixpanel.init('11f9f617e9cba868edb0593ecac8fd4e', { debug: false });
  mixpanel.track('Sign In');

  useEffect(() => {
    window.process = {
      ...window.process,
    };
  }, []);

  return (
    <div>
      <Provider store={store}>
        <UserAuthenticationProvider>
          <GQLProvider>
            <ProviderConfig />
          </GQLProvider>
        </UserAuthenticationProvider>
      </Provider>
    </div>
  );
};

export default hot(App);
